export default "__VITE_ASSET__5q0l5Wyf__"